import { useTranslation } from 'react-i18next';
import { SectionLabel } from '@/components/ui/calm';
import { providerLabel } from '@/lib/providers';
import { cn } from '@/lib/utils';

/** Грид провайдеров оплаты — общий для gift/traffic-шитов (активный = синий CTA). */

export function ProviderPills({
  providers,
  value,
  onChange,
}: {
  providers: string[];
  value: string;
  onChange: (p: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="space-y-2">
      <SectionLabel>{t('Pay with')}</SectionLabel>
      <div className="grid grid-cols-2 gap-2">
        {providers.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={cn(
              'px-3 py-2.5 rounded-xl text-xs font-bold transition-all active:scale-[0.98]',
              value === p ? 'calm-cta' : 'calm-card text-[#c2c4ca]',
            )}
          >
            {providerLabel(p)}
          </button>
        ))}
      </div>
    </div>
  );
}
